module.exports = __webpack_public_path__ + "static/media/paperclip.fbece819.svg";